module.exports = __webpack_public_path__ + "img/compentation_service_green.a5af96ae.svg";